import React from "react";
import ChatMessage from "./ChatMessage";
import UserChatMessage from "./UserChatMessage";

const ChatTurn = React.memo(function ChatTurn({
  userMessage,
  aiMessage,
  messageBlocks,
  webSearchResults,
  user,
  isLast,
  scroll,
  streaming = false,
  isParentFirstMount,
}) {
  return (
    <div style={{ paddingTop: "10px" }}>
      <UserChatMessage message={userMessage} user={user} isUser={true} />
      <ChatMessage
        message={aiMessage}
        messageBlocks={messageBlocks}
        webSearchResults={webSearchResults}
        user={user}
        isUser={false}
        streaming={streaming}
        isLast={isLast}
        scroll={scroll}
        isParentFirstMount={isParentFirstMount}
      />
    </div>
  );
});

export default ChatTurn;
